module.exports = __webpack_public_path__ + "static/media/quad4.2b068dff.png";